import { Component, OnInit, Input, Output, EventEmitter, ViewChild,ElementRef } from '@angular/core';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeService } from '../shared-service/root-scope.service';

@Component({
  selector: 'app-customized-circle-hint',
  templateUrl: './customized-circle-hint.component.html',
  styleUrls: ['./customized-circle-hint.component.scss']
})
export class CustomizedCircleHintComponent implements OnInit {
  @Output() callOnPositiveBtnClick = new EventEmitter();
  @Input() hintsMsg: any;
  @Input() position = "right";
  @Input() inlinePosition = false;
  @Input() isClickable = true;
  @ViewChild('customizedCircleHint', { static: false }) _htq: ElementRef;
  showHintContent = false;
  rootScopeData: RootScopeDeclare;
  isRtl: boolean;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit(): void {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  closeHint(status:string): void {  
    if(status === 'OK'){
      this.callOnPositiveBtnClick.emit();
    } else {
      this.showHintContent = false;
    } 
  }

  onclickCircle(): void {
    if (this.isClickable) {
      const htRect = this._htq.nativeElement.getBoundingClientRect();
      this.showHintContent = !this.showHintContent;
    }
  }
}
